import { ContactInformationDialogComponent } from './../contact-information-dialog/contact-information-dialog.component';
import { MAT_DIALOG_DATA, MatDialogRef,MatDialog } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-support-dialog',
  templateUrl: './support-dialog.component.html',
  styleUrls: ['./support-dialog.component.css']
})
export class SupportDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
  private dialogRef: MatDialogRef<SupportDialogComponent>,private matDialog:MatDialog) {
    dialogRef.disableClose = false;
   }

  ngOnInit() {
  }

  onClose() {
    this.dialogRef.close(true);
  }

  contactDialog(){
    this.dialogRef.close(true);
    this.matDialog.open(ContactInformationDialogComponent, {
     
    });
  }

}
